export const discoverImageUrls: Array<string> = [
  "/discover/1887511c-0162-4b20-819e-8bc2f20fe855.png",
  "/discover/d83ccc98-c013-4a06-b3d2-0756a449e9e2.png",
  "/discover/caa1345d-e1a8-4c07-a61b-4810ac77a7a6.png",
  "/discover/1228b56e-d4f8-4105-b147-35ff41970b4b.png",
  "/discover/c92fb4ab-97b1-428e-b425-d91acbeb062e.png",
  "/discover/aa975132-1d14-4531-bd8d-69741652c176.png",
  "/discover/95f63fdc-13be-4535-a404-d8a77afd548a.png",
  "/discover/5c36df61-5f4e-437e-a9a1-bd1b386710d1.png",
  "/discover/fd26a154-8a43-4d3f-aec2-4f0b86b5098b.png",
  "/discover/37cc9b57-a7fa-4e1c-8c7f-77a42244bab1.png",
  "/discover/7a4dde1b-a374-4a2d-ac02-a052a3afb53d.png",
  "/discover/dab68935-8d91-40b5-ad0b-53e86861d77c.png",
  "/discover/962a5129-44d5-4125-87ba-fe7341b1034b.png",
  "/discover/fa6d2146-513d-4faa-a1d7-21fa4b2a7fdf.png",
  "/discover/b4384a96-d9b3-4a2d-b777-a514defae934.png",
  "/discover/e511b0df-7d0e-488f-8518-f632622e29b4.png",
];

export const discoverImageIds: Array<string> = [
  "1887511c-0162-4b20-819e-8bc2f20fe855",
  "d83ccc98-c013-4a06-b3d2-0756a449e9e2",
  "caa1345d-e1a8-4c07-a61b-4810ac77a7a6",
  "1228b56e-d4f8-4105-b147-35ff41970b4b",
  "c92fb4ab-97b1-428e-b425-d91acbeb062e",
  "aa975132-1d14-4531-bd8d-69741652c176",
  "95f63fdc-13be-4535-a404-d8a77afd548a",
  "5c36df61-5f4e-437e-a9a1-bd1b386710d1",
  "fd26a154-8a43-4d3f-aec2-4f0b86b5098b",
  "37cc9b57-a7fa-4e1c-8c7f-77a42244bab1",
  "7a4dde1b-a374-4a2d-ac02-a052a3afb53d",
  "dab68935-8d91-40b5-ad0b-53e86861d77c",
  "962a5129-44d5-4125-87ba-fe7341b1034b",
  "fa6d2146-513d-4faa-a1d7-21fa4b2a7fdf",
  "b4384a96-d9b3-4a2d-b777-a514defae934",
  "e511b0df-7d0e-488f-8518-f632622e29b4",
];

export const discoverImageIdentityIds: Array<string> = [
  "protected/us-west-2:ceee7309-0969-47a7-b5bb-c4e8b74b6621/1887511c-0162-4b20-819e-8bc2f20fe855",
  "protected/us-west-2:ceee7309-0969-47a7-b5bb-c4e8b74b6621/d83ccc98-c013-4a06-b3d2-0756a449e9e2",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/caa1345d-e1a8-4c07-a61b-4810ac77a7a6",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/1228b56e-d4f8-4105-b147-35ff41970b4b",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/c92fb4ab-97b1-428e-b425-d91acbeb062e",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/aa975132-1d14-4531-bd8d-69741652c176",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/95f63fdc-13be-4535-a404-d8a77afd548a",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/5c36df61-5f4e-437e-a9a1-bd1b386710d1",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/fd26a154-8a43-4d3f-aec2-4f0b86b5098b",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/37cc9b57-a7fa-4e1c-8c7f-77a42244bab1",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/7a4dde1b-a374-4a2d-ac02-a052a3afb53d",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/dab68935-8d91-40b5-ad0b-53e86861d77c",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/962a5129-44d5-4125-87ba-fe7341b1034b",
  "protected/us-west-2:8ac24a23-bcb2-40e2-bc88-4c49214d6e71/fa6d2146-513d-4faa-a1d7-21fa4b2a7fdf",
  "protected/us-west-2:60c73e0a-7f29-4f64-89a2-50f91dfdea0e/b4384a96-d9b3-4a2d-b777-a514defae934",
  "protected/us-west-2:60c73e0a-7f29-4f64-89a2-50f91dfdea0e/e511b0df-7d0e-488f-8518-f632622e29b4",
];

export const feelingOptions = [
  "Empowering",
  "Dreamy",
  "Energetic",
  "Simple",
  "Joyful",
  "Peaceful",
  "Nostalgic",
  "Transcendent",
];

export const subjectOptions = [
  "Abstract",
  "Figurative",
  "Landscape",
  "Still Life",
];

export const subjectSubOptions = [
  "Organic",
  "Geometric",
  "Single Portrait",
  "Family",
  "Seascape",
  "Cityscape",
  "Mountainscape",
  "Skyscape",
  "Land",
  "Flowers",
  "Household Items",
  "Animals",
];

export const stylesOptions = [
  "Deconstructivism",
  "Pop",
  "Abstract Expressionism",
  "Surrealism",
  "Photorealism",
  "Op Art",
  "Graffiti",
  "Dadaism",
  "Minimalism",
  "Magic Realism",
  "Harlem Renaissance",
  "Precisionism",
  "Bauhaus",
  "Art Deco",
  "Cubism",
  "German Expressionism",
  "Art Nouveau",
  "Pointillism",
  "Impressionism",
  "Realism",
  "Vienna Secession",
  "Romanticism",
  "Luminism",
  "Baroque",
  "Mannerism",
  "Classicism",
  "Italian Renaissance",
  "Gothic",
  "Fauvism",
  "Orphism",
  "De Stijl",
];

export const mediumOptions = ["Oil", "Watercolor", "Pastel", "Pencil", "Ink"];

export const colorOptions = [
  "Warm",
  "Cool",
  "Bright",
  "Dark",
  "Soft",
  "Neutral",
];

export const boolOptions = ["true", "false", ""];

export const boolCategories = [
  { category: "Approve", options: ["true", "false", "null"] },
  { category: "Deleted", options: ["true", "false", "null"] },
  { category: "like", options: ["true", "false", "null"] },
];
